import {Vue} from 'vue-property-decorator';
import AppMap from '@/components/map/map.vue';
import AppMapFilter from '@/components/map-filter/map-filter.vue';
import AppMapListObject from '@/components/map-list-object/map-list-object.vue';
import AppMapObjects from '@/components/map-objects/map-objects.vue';
import AppMapObject from '@/components/map-object/map-object.vue';
import AppMapSearch from '@/components/map-search/map-serarch.vue';
import AppMapObjectActions from '@/components/map-object-actions/map-object-actions.vue';
import AppMapObjectContainer from '@/components/map-object-container/map-object-container.vue';
import AppMapInfoContainer from '@/components/map-info-container/map-info-container.vue';
import AppCheckbox from '@/components/checkbox/checkbox.vue';
import AppRadio from '@/components/radio/radio.vue';
import AppSwitch from '@/components/switch/switch.vue';
import AppMapFilterOptionGroup from '@/components/map-filter-option-group/map-filter-option-group.vue';
import AppScrollBox from '@/components/scroll-box/scroll-box.vue';
import AppObjectReport from '@/components/object-report/object-report.vue';
import AppFilesUpload from '@/components/files-upload/files-upload.vue';
import AppForestGame from '@/components/forest-game/forest-game.vue';
import AppGameObject from '@/components/game-object/game-object.vue';
import AppForestGameTimer from '@/components/forest-game-timer/forest-game-timer.vue';
import AppForestGameAnswer from '@/components/forest-game-answer/forest-game-answer.vue';
import AppMiniMap from '@/components/mini-map/mini-map.vue';
import AppMiniMapForRoute from '@/components/mini-map-for-route/mini-map-for-route.vue';
import AppMiniMapForObject from '@/components/mini-map-for-object/mini-map-for-object.vue';
import AppPopup from '@/components/popup/popup.vue';
import AppConfirmPopup from '@/components/confirm-popup/confirm-popup.vue';
import AppInfoPopup from '@/components/info-popup/info-popup.vue';
import AppSpinner from '@/components/spinner/spinner.vue';
import AppEnlargedImage from '@/components/enlarged-image/enlarged-image.vue';

Vue.component('AppMap', AppMap);
Vue.component('AppMapFilter', AppMapFilter);
Vue.component('AppMapListObject', AppMapListObject);
Vue.component('AppMapObjects', AppMapObjects);
Vue.component('AppMapObject', AppMapObject);
Vue.component('AppMapSearch', AppMapSearch);
Vue.component('AppMapObjectActions', AppMapObjectActions);
Vue.component('AppMapObjectContainer', AppMapObjectContainer);
Vue.component('AppMapInfoContainer', AppMapInfoContainer);
Vue.component('AppMiniMap', AppMiniMap);
Vue.component('AppMiniMapForRoute', AppMiniMapForRoute);
Vue.component('AppMiniMapForObject', AppMiniMapForObject);
Vue.component('AppCheckbox', AppCheckbox);
Vue.component('AppRadio', AppRadio);
Vue.component('AppSwitch', AppSwitch);
Vue.component('AppMapFilterOptionGroup', AppMapFilterOptionGroup);
Vue.component('AppScrollBox', AppScrollBox);
Vue.component('AppObjectReport', AppObjectReport);
Vue.component('AppFilesUpload', AppFilesUpload);
Vue.component('AppForestGame', AppForestGame);
Vue.component('AppGameObject', AppGameObject);
Vue.component('AppForestGameTimer', AppForestGameTimer);
Vue.component('AppForestGameAnswer', AppForestGameAnswer);
Vue.component('AppPopup', AppPopup);
Vue.component('AppConfirmPopup', AppConfirmPopup);
Vue.component('AppInfoPopup', AppInfoPopup);
Vue.component('AppSpinner', AppSpinner);
Vue.component('AppEnlargedImage', AppEnlargedImage);
